import { render, staticRenderFns } from "./Spc.vue?vue&type=template&id=8ebf49ca&scoped=true&"
import script from "./Spc.vue?vue&type=script&lang=js&"
export * from "./Spc.vue?vue&type=script&lang=js&"
import style0 from "./Spc.vue?vue&type=style&index=0&id=8ebf49ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ebf49ca",
  null
  
)

export default component.exports